/**
 * Created by alex.shmaltsuev on 2016-04-11.
 */

import {createAction} from 'redux-actions';
import C from '../constants/scoreBoard';
import {axiosInstance, getAjaxRequest} from '../utils/helpers';
import {setFetchingCount} from './app';
import homeC from '../constants/home';

/*
 * gets active tabs and then initiates a request for each tabs list
 * also sets default active tab to first in list in case none is defined (initialization)
 *
 * why are we doing it here?
 * see: http://redux.js.org/docs/faq/CodeStructure.html#structure-business-logic
 *
 * */
export function getscoreBoardTabs(isShowAll = false,tabName,offset) {
    
    return (dispatch, getState) => {
        // get from action instead of store
        let limit= C.SERVICE_REQ_WIDGET_LIMIT;
        const scoreboardWidget=getState().home.getIn([homeC.WIDGET_LIST]).widgets.scoreboard;
            const pageSize=scoreboardWidget.recordsDisplayedInLists||limit;
        let tabsOrder=scoreboardWidget.widgetData.tabsOrder;
        let tabs=scoreboardWidget?scoreboardWidget.tabs:null;
      
        if (isShowAll) {
            limit = 500;
            let scoreboardtabs = getState().scoreBoard.get(C.TABS);
            let lsShowAllFilter = localStorage.showAllFilter ? JSON.parse(localStorage.showAllFilter) : {};
            tabsOrder.forEach((item) => {
                if (scoreboardtabs.get(item) && scoreboardtabs.get(item).get(C.SHOW_ALL_FILTER)) {
                    tabs[item][C.SHOW_ALL_FILTER] = scoreboardtabs.get(item).get(C.SHOW_ALL_FILTER)
                }
                else if (lsShowAllFilter[item] && lsShowAllFilter[item].showAllFilter) {
                    Object.keys(lsShowAllFilter[item].showAllFilter.captions).forEach(key => {
                        if (!lsShowAllFilter[item].showAllFilter[key].caption) {
                            lsShowAllFilter[item].showAllFilter[key].caption = lsShowAllFilter[item].showAllFilter.captions[key];
                        }
                    });
                    tabs[item][C.SHOW_ALL_FILTER] = lsShowAllFilter[item].showAllFilter;
                }
            });


        }
        dispatch({
            type: C.RECORDS_DISPLAY_IN_LIST,
            payload: pageSize
        });
        if (tabs && tabsOrder) {
            dispatch(setFetchingCount(true));
            //store the scoreboard tabs captions and the tabs order in the state
            dispatch({
                         type: C.SCORE_BOARD_TABS,
                         payload: tabs
                     });
            dispatch({
                         type: C.SCORE_BOARD_TABS_ORDER,
                         payload: tabsOrder
                     });
            //on first tabs fetch, if no active tab is set, set it to the first tab
            const currentActiveTabName = getState().scoreBoard.get(C.ACTIVE_TAB_NAME);
            let activeTabName = currentActiveTabName;
            if (currentActiveTabName === '' || tabsOrder.filter(
                    item => item === currentActiveTabName).length === 0) {
                activeTabName = tabsOrder[0];
                dispatch(updateActiveTabName(tabsOrder[0]));
            }
            let shouldGetAllTabsData = getState().browser.lessThan.small && !isShowAll;
            
            //get tabs content
            if (tabName)
            {
                
                getTabArray(tabName, dispatch, !isShowAll?limit:pageSize||limit, activeTabName, true, tabs,offset,isShowAll)
            }else{
                tabsOrder.forEach((tabName) => getTabArray(tabName, dispatch, !isShowAll?limit:pageSize||limit, activeTabName, shouldGetAllTabsData,tabs,offset,isShowAll));
            }
            return dispatch(setFetchingCount(false));
        }
    }
}

let tabsMeta = {};
tabsMeta[C.MY_REQUEST_TAB] = {
    getRequestsFunc: getServiceCatalogActiveRequests,
    getCountFunc: getServiceCatalogActiveRequestsCount

};
tabsMeta[C.RECENTLY_CLOSED_TAB] = {
    getRequestsFunc: getServiceCatalogClosedRequests,
    getCountFunc: getServiceCatalogClosedRequestsCount

};
tabsMeta[C.SUPERVISED_REQUESTS_TAB] = {
    getRequestsFunc: getServiceCatalogSupervisedRequests,
    getCountFunc: getServiceCatalogSupervisedRequestsCount

};
tabsMeta[C.PENDING_MY_APPROVAL_TAB] = {
    getRequestsFunc: getServiceCatalogPendingRequests,
    getCountFunc: getServiceCatalogPendingRequestsCount
};

/**
 * return string of staticFilter Id
 * @param tabName
 * @param tabs
 */

function getstaticFilterId(tabName, tabs) {
   return tabs[tabName].staticFilterId;
}

/**
 *
 * @param tabName
 * @param tabs
 * @returns  showAllFilter for tab with tabName
 */
function getShowAllFilter(tabName, tabs) {
    if(tabs[tabName][C.SHOW_ALL_FILTER]){
        return tabs[tabName][C.SHOW_ALL_FILTER].filterData;
    }
    else{
        return '';
    }
}

function getArchivedParam(tabName, tabs){
    return tabs[tabName].showArchived?
           'archive=1,0':'';
}

/**
 * return string of all custom fields
 * @param tabName
 * @param tabs
 */

function getAllFields(tabName, tabs) {
    return tabs[tabName].badges.concat(tabs[tabName].columns).join(',');
}

/**
 * dispatching the tabs array and count for updating the store
 * @param tabName
 * @param dispatch
 * @param limit
 * @param activeTabId
 * @param getAllTabsData
 * @param tabs
 */
export function getTabArray(tabName, dispatch, limit, activeTabName, getAllTabsData, tabs,offset,isShowAll) {
    let fields = getAllFields(tabName, tabs);
    let staticFilterId = getstaticFilterId(tabName, tabs);
    let showAllFilter = getShowAllFilter(tabName, tabs)||'';
    let archivedParam = getArchivedParam(tabName, tabs);
    if (activeTabName === tabName) {
        dispatch(setFetchingCount(true));
        dispatch(tabsMeta[tabName].getRequestsFunc(limit, fields, staticFilterId, showAllFilter, archivedParam,offset,isShowAll)).finally(() => {
            dispatch(setFetchingCount(false));
        });
        dispatch(setFetchingCount(true));
        dispatch(tabsMeta[tabName].getCountFunc(staticFilterId, showAllFilter, archivedParam,offset)).finally(() => {
            dispatch(setFetchingCount(false));
        });
    } else {
        if (getAllTabsData) {
            dispatch(tabsMeta[tabName].getRequestsFunc(limit, fields));
        }
        dispatch(tabsMeta[tabName].getCountFunc(staticFilterId, showAllFilter, archivedParam,offset));
    }
}


export function updatePagination(pageNumber,tabName)
{
    return (dispatch, getState) => {
        const scoreboardWidget=getState().home.getIn([homeC.WIDGET_LIST]).widgets.scoreboard;
        let tabs=scoreboardWidget?scoreboardWidget.tabs:null;
        const limit =2;
        const fields = getAllFields(tabName, tabs);

        const staticFilterId = getstaticFilterId(tabName, tabs);
        const showAllFilter = getShowAllFilter(tabName, tabs)||'';
        const archivedParam = getArchivedParam(tabName, tabs);
        let shouldGetAllTabsData = getState().browser.lessThan.small ;

        getTabArray(tabName, dispatch, limit, tabName, shouldGetAllTabsData, tabs);

    }
    
}
export function getServiceCatalogActiveRequests(limit,fields, staticFilterId, showAllFilter, archivedParam,offset,isShowAll) {
    const offsetQuery = offset?'&offset='+offset:'';
    let url = `api/v1/sr?view=Service Catalog Active Requests&limit=${limit}&status=%24%7Blist.active%7D,0&sort=update_time&dir=desc&staticFilterId=${staticFilterId}&fields=id,sr_type,title,${fields}${offsetQuery}`;
    if (!isShowAll) {
        return getAjaxRequest(url, C.SERVICE_CATALOG_ACTIVE_REQUESTS_WIDGET);
    } else {
        if(showAllFilter.includes('status'))
        {
           url = url.replace('&status=%24%7Blist.active%7D,0','');
        }
        url+=showAllFilter;
        return getAjaxRequest(url, C.SERVICE_CATALOG_ACTIVE_REQUESTS);
    }
}

export function getServiceCatalogClosedRequests(limit,fields, staticFilterId, showAllFilter, archivedParam,offset,isShowAll) {
    const offsetQuery = offset?'&offset='+offset:'';
    let url = `api/v1/sr?view=Service Catalog Closed Requests&limit=${limit}&${archivedParam}&status=%24%7Blist.close%7D&sort=update_time&dir=desc&staticFilterId=${staticFilterId}&fields=id,sr_type,title,${fields}${offsetQuery}`;
    if (!isShowAll) {
        return getAjaxRequest(url, C.SERVICE_CATALOG_CLOSED_REQUESTS_WIDGET);
    } else {
        if(showAllFilter.includes('status'))
        {
           url = url.replace('&status=%24%7Blist.close%7D','');
        }
        url+=showAllFilter;
        return getAjaxRequest(url, C.SERVICE_CATALOG_CLOSED_REQUESTS);
    }
}

export function getServiceCatalogSupervisedRequests(limit,fields, staticFilterId, showAllFilter, archivedParam,offset,isShowAll) {
    const offsetQuery = offset?'&offset='+offset:'';
    let url = `api/v1/sr?view=Service Catalog Supervised Requests&limit=${limit}&${archivedParam}&sort=update_time&dir=desc&supervisedRequests=Y&staticFilterId=${staticFilterId}&fields=id,sr_type,title,${fields}${offsetQuery}`;
    if (limit == C.SERVICE_REQ_WIDGET_LIMIT) {
        return getAjaxRequest(url, C.SERVICE_CATALOG_SUPERVISED_REQUESTS_WIDGET);
    } else {
        url+=showAllFilter;
        return getAjaxRequest(url, C.SERVICE_CATALOG_SUPERVISED_REQUESTS);
    }
}

export function getServiceCatalogPendingRequests(limit,fields, staticFilterId, showAllFilter, archivedParam,offset,isShowAll) {
    const offsetQuery = offset?'&offset='+offset:'';
    let url = `api/v1/action_item?view=Service Catalog Pending Actions&limit=${limit}&sort=enabled_time&dir=desc&staticFilterId=${staticFilterId}&fields=sr_id,title,${fields}${offsetQuery}`;
    if (!isShowAll) {
        return getAjaxRequest(url, C.SERVICE_CATALOG_PENDING_REQUESTS_WIDGET);
    } else {
        url+=showAllFilter;
        return getAjaxRequest(url, C.SERVICE_CATALOG_PENDING_REQUESTS);
    }
}

export function getServiceCatalogActiveRequestsCount(staticFilterId, showAllFilter, archivedParam) {
    let url = `api/v1/sr/count?view=Service Catalog Active Requests&status=%24%7Blist.active%7D,0&sort=enabled_time&dir=desc&staticFilterId=${staticFilterId}${showAllFilter}`;
    if(showAllFilter.includes('status'))
    {
       url = url.replace('&status=%24%7Blist.active%7D,0','');
    }
    return getAjaxRequest(url, C.SERVICE_CATALOG_ACTIVE_REQUESTS_COUNT);
}

export function getServiceCatalogClosedRequestsCount(staticFilterId, showAllFilter, archivedParam) {
    let url = `api/v1/sr/count?view=Service Catalog Closed Requests&status=%24%7Blist.close%7D&sort=update_time&${archivedParam}&dir=desc&staticFilterId=${staticFilterId}${showAllFilter}`;
    if(showAllFilter.includes('status'))
    {
        url = url.replace('&status=%24%7Blist.close%7D','');
    }
    return getAjaxRequest(url, C.SERVICE_CATALOG_CLOSED_REQUESTS_COUNT);
}

export function getServiceCatalogSupervisedRequestsCount(staticFilterId, showAllFilter, archivedParam) {
    let url = `api/v1/sr/count?view=Service Catalog Supervised Requests&sort=update_time&${archivedParam}&dir=desc&supervisedRequests=Y&staticFilterId=${staticFilterId}${showAllFilter}`;
    if(showAllFilter.includes('status'))
    {
       url = url.replace('&status=%24%7Blist.close%7D','');
    }
    return getAjaxRequest(url, C.SERVICE_CATALOG_SUPERVISED_REQUESTS_COUNT);
}

export function getServiceCatalogPendingRequestsCount(staticFilterId, showAllFilter, archivedParam) {
    let url = `api/v1/action_item/count?view=Service Catalog Pending Actions&sort=update_time&dir=desc&staticFilterId=${staticFilterId}${showAllFilter}`;
    return getAjaxRequest(url, C.SERVICE_CATALOG_PENDING_REQUESTS_COUNT);
}

//todo: consider add IsMobileHome param to methos getTabArray according to FR requirements
export function getServiceCatalogPendingTabWidget(dispatch, limit) {
    getTabArray({name: C.PENDING_MY_APPROVAL_TAB}, dispatch, limit);
}

export function completePendingItemAction(id, isShowAll) {
    return (dispatch) => {
        let limit = isShowAll ? 500 : C.SERVICE_REQ_WIDGET_LIMIT;
        let url = `api/v1/action_item/${id}/${C.SERVICE_CATALOG_PENDING_COMPLETE}`;
        putPendingItemAction(url)
            .then(() => getServiceCatalogPendingTabWidget(dispatch, limit));
    }
}

export function approvePendingItemAction(id, isShowAll) {
    return (dispatch) => {
        let limit = isShowAll ? 500 : C.SERVICE_REQ_WIDGET_LIMIT;
        let url = `api/v1/action_item/${id}/${C.SERVICE_CATALOG_PENDING_APPROVE}`;
        putPendingItemAction(url)
            .then(() => getServiceCatalogPendingTabWidget(dispatch, limit));
    }
}

export function rejectPendingItemAction(id, isShowAll) {
    return (dispatch) => {
        let limit = isShowAll ? 500 : C.SERVICE_REQ_WIDGET_LIMIT;
        let url = `api/v1/action_item/${id}/${C.SERVICE_CATALOG_PENDING_REJECT}`;
        putPendingItemAction(url)
            .then(() => getServiceCatalogPendingTabWidget(dispatch, limit));
    }
}

export function putPendingItemAction(url) {
    return axiosInstance.put(url);
}

export function updateActiveTabName(tabName) {
    let activeTabAction = createAction(C.SCORE_BOARD_ACTIVE_TAB, activeTabName => activeTabName);
    return activeTabAction(tabName);
}

export function resetScoreboard() {
    return function (dispatch) {
        dispatch({
                     type: C.SERVICE_CATALOG_RESET_COMP,
                     payload: []
                 });
    }
}


export function updateFilter(filterParams, activeTabName) {
    return function (dispatch) {
        let ids;
        let idsArr=[];
        let values;
        let hintArr=[];
        const hintLength=6;
        const newCaptions = {};
        let hintCount=0;
        const categoryFilterNames = ['problem_type', 'problem_sub_type', 'third_level_category'];
        const {hint, filterData, captions, ...rest} = filterParams;
        Object.keys(rest).forEach(key => {
            const {caption, ...filter} = rest[key];
            ids = Object.keys(filter).map(e => {
                return filter[e].id;
            });
            if (ids.length > 0) {
                idsArr.push(`${key}=${ids}`);
                newCaptions[key] = caption;
                hintCount++;
            }
            values = Object.keys(filter).map(e=> {
                return filter[e].caption;
            });
            if (values.length > 0 && hintArr.length < hintLength) {
                hintArr.push(`${caption}: ${values.join(', ')}`);
            }
        });

        filterParams.hint=hintCount<=hintLength?hintArr.join('\n'):`${hintArr.join('\n')}\n...`;
        filterParams.filterData='&' + (idsArr).join('&');
        filterParams.captions=newCaptions;
        let filter = localStorage.showAllFilter ? JSON.parse(localStorage.showAllFilter) : {};
        filter[activeTabName] = filter[activeTabName] || {};
        filter[activeTabName].showAllFilter = filterParams;
        localStorage.showAllFilter = JSON.stringify(filter);
        return dispatch({
                            type: C.UPDATE_SHOW_ALL_FILTER,
                            payload: filterParams
                        });
    }
}


// WEBPACK FOOTER //
// ./actions/scoreBoard.js